import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import DynamicForm from "Component/DynamicForm";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { instance } from "../../../../../../Actions/AxiosInstance";
import { ApprovalWorkflow } from "../../../../../../Actions/commonAction";
import CheckImg from "../../../../../../Assets/Images/aaa.png";
import createstore from "../../../../../../store";
import SelectList from "../../../../../../Component/SelectList/SelectList";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
});

class ReviewWorkflow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isskippable: false,
      isskip: false,
      approvalworkflowpolicyid: this.props.approvalworkflowpolicyid,
      value: 0,
      expanded02: false,
      Employees: ["1"],
      dropdown: [
        { displayvalue: 1, displayname: "Employee First" },
        { displayvalue: 2, displayname: "Employee Second" },
      ],
      approverTypes: [],
      employeeList: [],
      backupemployeeid: "",
      selectedBackupEmployeeId: {},
      approvalworkflowtypeid: null,
      approvertypeids: [],
      selectedApproverTypeIds: [],
      employeeIds: [],
      selectedEmployeeIds: [],
      selectedEmployee: {},
      employeeid: "",
      approvalpermission: {
        isskipparticipant: false,
        isexcluderating: false,
        isadhoc: false,
        iscancle: false,
        isonhold: false,
        isreleased: false,
        ispreference: false,
      },
      approvalworkflowdetailid: "",
      showEmployeeList: false,
      bemployeeIds: [],
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.GetApproverType();
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    this.setState({ accountid, subscriptionid }, () => {
      this.GetEmployeeList();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  GetEmployeeList() {
    const data = {
      accountid: this.state.accountid,
      statusid: null,
      subscriptionid: this.state.subscriptionid,
      featurekey: "approvalWorkflow",
    };
    const URL = `subscription/getemployeelist`;
    // let URL = `subscription/getemployeelist/${this.state.accountid}/${this.state.subscriptionid}`
    instance
      .post(URL, data)
      .then((result) => {
        let employeeList = [];
        result.data.result.length > 0
          ? (employeeList = result.data.result)
          : (employeeList = []);
        // employeeList.push({ "displayname": "Select employee", "displayvalue": "" }, ...result.data.result)
        this.setState(
          { employeeList, employeeListForLevelBased: employeeList },
          () => {
            const approvalworkflowInfo = this.props.approvalWorkflowReducer;
            if (approvalworkflowInfo.approvalworkflowdetail) {
              const index =
                approvalworkflowInfo.approvalworkflowdetail.findIndex(
                  (x) => x.workflowfortypeid == 6,
                );
              if (index > -1) {
                const ReducerDetails =
                  approvalworkflowInfo.approvalworkflowdetail;
                this.setState({ ReducerDetails }, () => {
                  setTimeout(() => {
                    this.AssignDetails();
                  }, 500);
                });
              } else {
                setTimeout(() => {
                  this.GetApprovalWorkflowPolicyDetails();
                }, 500);
              }
            } else {
              setTimeout(() => {
                this.GetApprovalWorkflowPolicyDetails();
              }, 500);
            }
          },
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetApproverType() {
    instance
      .get("superuser/getmastercode/ApproverType")
      .then((result) => {
        let approverTypes = [];
        if (result.data.result.length != 0) {
          console.log("result.data.result: ", result.data.result);
          const tempindex = result.data.result.findIndex(
            (x) => x.displayname == "Secondary Manager",
          );
          if (tempindex != -1) {
            result.data.result[tempindex].displayname = "Additional Manager";
          }
          approverTypes = result.data.result;
        }
        // approverTypes.push({ "displayname": "Select Approver", "displayvalue": "" }, ...result.data.result)
        this.setState({ approverTypes });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  handleExpandClick02 = () => {
    this.setState((state) => ({
      expanded02: !state.expanded02,
      approvalworkflowtypeid: 1,
      showEmployeeList: false,
      employeeIds: [],
      selectedEmployeeIds: [],
      selectedApproverTypeIds: [],
      approvertypeids: [],
      LevelWiseData: [],
      ErApprovalworkflowtype: false,
      ErApprovalType: false,
      ErEmployees: false,
    }));
  };

  UpdateEmployeeIds = (selectedItems) => {
    const employeeIds = [];
    for (const item of selectedItems) {
      employeeIds.push(item.displayvalue);
    }
    this.setState({
      employeeIds,
      selectedEmployeeIds: selectedItems,
      ErEmployees: false,
    });
    // () => this.UpdateApprovalWorkFlowReducer());
  };

  UpdateApprovertypeIds = (selectedItems) => {
    const approvertypeids = [];
    let showEmployeeList = false;
    for (const item of selectedItems) {
      if (item.displayvalue) {
        approvertypeids.push(item.displayvalue);
      }
    }
    for (const item of selectedItems) {
      if (item.displayvalue == 3) {
        showEmployeeList = true;
      }
    }
    this.setState({
      approvertypeids,
      selectedApproverTypeIds: selectedItems,
      showEmployeeList,
      ErApprovalType: false,
    });
  };

  GetApprovalWorkflowPolicyDetails() {
    if (this.state.approvalworkflowpolicyid) {
      const URL = `/subscription/approvalworkflowpolicydetails/${this.state.approvalworkflowpolicyid}`;
      instance
        .get(URL)
        .then((result) => {
          const Details = result.data.result;
          this.setState({ Details }, () => {
            this.AssignDetails();
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  AssignDetails() {
    let approvalWorkFlowDetailPolicy = [];
    let approverDetail = [];
    let approvalworkflowdetail = [];
    let approvalpermission = null;
    const approvalworkflowInfo = this.props.approvalWorkflowReducer;
    console.log("approvalworkflowInfo: ", approvalworkflowInfo);
    if (this.state.ReducerDetails) {
      approvalWorkFlowDetailPolicy = this.state.ReducerDetails;
      const index = this.state.ReducerDetails.findIndex(
        (x) => x.workflowfortypeid == 6,
      );
      index > -1
        ? (approverDetail = this.state.ReducerDetails[index].approverdetail)
        : (approverDetail = []);
      const index1 =
        this.props.approvalWorkflowReducer.approvalworkflowdetail.findIndex(
          (x) => x.workflowfortypeid == 6,
        );
      if (index1 > -1) {
        approvalworkflowdetail = [
          ...new Set(
            approvalworkflowInfo.approvalworkflowdetail[index1].approverdetail,
          ),
        ];
        console.log("approvalworkflowdetail: ", approvalworkflowdetail);
      }
      approvalworkflowdetail.map(
        (x1) =>
          (x1.approvertypeid = Number.isInteger(x1.approvertypeid)
            ? x1.approvertypeid
            : x1.approvertypeid == "Department Head"
            ? 4
            : x1.approvertypeid == "Primary Manager"
            ? 1
            : x1.approvertypeid == "Secondary Manager"
            ? 2
            : x1.approvertypeid == "Additional Employee"
            ? 3
            : x1.approvertypeid == "Business Unit Head"
            ? 5
            : null),
      );
      const newindex = approvalworkflowInfo.approvalworkflowdetail.findIndex(
        (x) => x.workflowfortypeid == 6,
      );
      if (newindex > -1) {
        approvalworkflowInfo.approvalworkflowdetail[newindex].approverdetail =
          approvalworkflowdetail;
      }
      console.log("approvalworkflowdetail: ", approvalworkflowdetail);
    } else {
      approvalWorkFlowDetailPolicy =
        this.state.Details.approvalWorkFlowDetailPolicy;
      approverDetail = this.state.Details.approverDetail;
      approvalpermission = this.state.Details.approvalpermission;
    }

    approvalWorkFlowDetailPolicy.map((data) => {
      if (data.workflowfortypeid == 6) {
        const approvalworkflowdetailid = data.approvalworkflowdetailid
          ? data.approvalworkflowdetailid
          : 0;
        const { approvalworkflowpolicyid } = data;
        const { workflowfortypeid } = data;
        const { isselfapproval } = data;
        const { backupemployeeid } = data;
        const selectedBackupEmployeeid = this.state.employeeList.find(
          (x) => x.displayvalue == data.backupemployeeid,
        );
        const { onapproverchange } = data;
        const { approvalworkflowtypeid } = data;
        let expanded02 = false;
        let showEmployeeList;
        if (data.approvalworkflowtypeid == 1) {
          expanded02 = true;
        }
        const approvertypeids = [];
        const selectedApproverTypeIds = [];
        const employeeIds = [];
        const selectedEmployeeIds = [];
        const tempindex = approverDetail.findIndex(
          (info) => info.approvertypeid == "Secondary Manager",
        );
        if (tempindex != -1) {
          approverDetail[tempindex].approvertypeid = "Additional Manager";
        }

        if (data.approvalworkflowtypeid != 3) {
          approverDetail.map((info) => {
            if (info.approvalworkflowdetailid == approvalworkflowdetailid) {
              const selectedApprover = this.state.approverTypes.find(
                (x) =>
                  x.displayname == info.approvertypeid ||
                  x.displayvalue == info.approvertypeid,
              );
              if (selectedApprover) {
                selectedApprover.approvalworkflowdetailid =
                  approvalworkflowdetailid;
                selectedApprover.approverdetailid = info.approverdetailid;
              }

              if (!approvertypeids.find((x) => x == info.approvertypeid)) {
                // this.state.approvalworkflowdetailid ? selectedApproverTypeIds.push(info.approvertypeid) : selectedApproverTypeIds.push(selectedApprover);
                selectedApproverTypeIds.push(selectedApprover);
                approvertypeids.push(info.approvertypeid);
              }
              if (
                info.approvertypeid == 3 ||
                info.approvertypeid == "Additional Employee"
              ) {
                showEmployeeList = true;
                const selectedEmployee = this.state.employeeList.find(
                  (x) => x.displayvalue == info.employeeid,
                );

                // selectedEmployeeIds.push(selectedEmployee);
                // employeeIds.push(info.employeeid);
                const obj = selectedEmployeeIds.find(
                  (x) => x.displayvalue == selectedEmployee.displayvalue,
                );
                if (!obj) {
                  selectedEmployeeIds.push(selectedEmployee);
                }
                // selectedEmployeeIds.push(selectedEmployee);
                console.log("selectedEmployeeIds: ", selectedEmployeeIds);
                const obj1 = employeeIds.find((x) => x == info.employeeid);
                if (!obj1) {
                  employeeIds.push(info.employeeid);
                }
              }
            }
          });
        }

        this.setState({
          approvalworkflowdetailid,
          approvalworkflowpolicyid,
          workflowfortypeid,
          approvalworkflowtypeid,
          isselfapproval,
          backupemployeeid,
          selectedBackupEmployeeid,
          onapproverchange,
          expanded02,
          showEmployeeList,
          approvertypeids,
          selectedApproverTypeIds,
          selectedEmployeeIds,
          employeeIds,
          approvalpermission: data.approvalpermission
            ? data.approvalpermission
            : this.state.approvalpermission,
          bemployeeIds: employeeIds,
        });
      }
    });
  }

  Validate() {
    let isValid = true;
    let ErApprovalworkflowtype = false;
    let ErApprovalType = false;
    let ErEmployees = false;

    if (!this.state.approvalworkflowtypeid) {
      ErApprovalworkflowtype = true;
      this.setState({ ErApprovalworkflowtype });
      this.props.enqueueSnackbar("Please Select Approval Workflow Type", {
        variant: "error",
      });
      return (isValid = false);
    }
    if (this.state.approvalworkflowtypeid != 4) {
      ErApprovalworkflowtype = false;
      this.setState({ ErApprovalworkflowtype });

      if (this.state.approvalworkflowtypeid != 3) {
        if (this.state.approvertypeids.length == 0) {
          ErApprovalType = true;
          this.setState({ ErApprovalType });
          this.props.enqueueSnackbar("Please Select Approver", {
            variant: "error",
          });
          return (isValid = false);
        }
        ErApprovalType = false;
        this.setState({ ErApprovalType });
        const arr = this.state.approvertypeids.filter((y) => y == 3);
        if (arr.length != 0 && this.state.employeeIds.length == 0) {
          ErEmployees = true;
          this.setState({ ErEmployees });
          this.props.enqueueSnackbar("Please Select Employee", {
            variant: "error",
          });
          return (isValid = false);
        }
        ErEmployees = false;
        this.setState({ ErEmployees });
      }
    }
    return isValid;
  }

  handleChange(value, key) {
    const { approvalpermission } = this.state;
    if (key == "isreleased") {
      approvalpermission.iscancle = value;
      approvalpermission.isonhold = value;
    }
    approvalpermission[key] = value;
    this.setState({
      approvalpermission,
    });
  }

  UpdateApprovalWorkFlowReducer() {
    const approvalworkflowdetail = this.props.approvalWorkflowReducer;
    approvalworkflowdetail.approvalreviewworkflowpolicyid = this.state
      .approvalworkflowtypeid
      ? this.state.approvalworkflowtypeid
      : null;
    approvalworkflowdetail.approvalreviewworkflowisskip =
      this.state.isskippable;
    this.props.ApprovalWorkflow({ ...approvalworkflowdetail });
    const { isskip } = this.state;
    const aprwork =
      this.props.approvalWorkflowReducer.approvalworkflowdetail &&
      this.props.approvalWorkflowReducer.approvalworkflowdetail.find(
        (apr) => apr.workflowfortypeid == 6,
      );
    if (!this.Validate()) {
      // this.props.enqueueSnackbar('Please select all required fields', { variant: 'error' });
      this.props.setTabValue("P");
    } else {
      let data;
      data = {
        approvalworkflowdetailid: this.state.approvalworkflowdetailid
          ? this.state.approvalworkflowdetailid
          : 0,
        workflowfortypeid: 6,
        isselfapproval: false,
        backupemployeeid: null,
        escalationdays: null,
        escalationactiontypeid: null,
        onapproverchange: null,
        approvalworkflowtypeid: this.state.approvalworkflowtypeid,
        approverdetail: [],
        approvalpermission: this.state.approvalpermission,
      };

      this.state.selectedApproverTypeIds.map((approvertype) => {
        const approverTypeItem = {
          approvalworkflowdetailid: this.state.approvalworkflowdetailid
            ? this.state.approvalworkflowdetailid
            : 0,
          approverdetailid: 0,
          approvertypeid: approvertype && approvertype.displayvalue,
          employeeid: null,
          levelid: 1,
        };
        if (approvertype.displayvalue == 3) {
          this.state.employeeIds.map((employeeId) => {
            const existemp = this.state.bemployeeIds.find(
              (id) => id == employeeId,
            );
            const getId = (employeeId1) => {
              const x =
                aprwork &&
                aprwork.approverdetail.find(
                  (emp) => emp.employeeid == employeeId1,
                );
              return x.approverdetailid || 0;
            };

            let employeeItem = null;
            if (existemp) {
              employeeItem = {
                approvalworkflowdetailid: this.state.approvalworkflowdetailid
                  ? this.state.approvalworkflowdetailid
                  : 0,
                approverdetailid: getId(employeeId),
                approvertypeid: approvertype && approvertype.displayvalue,
                employeeid: employeeId,
                levelid: 1,
              };
            } else {
              employeeItem = {
                approvalworkflowdetailid: this.state.approvalworkflowdetailid
                  ? this.state.approvalworkflowdetailid
                  : 0,
                approverdetailid: 0,
                approvertypeid: approvertype && approvertype.displayvalue,
                employeeid: employeeId,
                levelid: 1,
              };
            }

            data.approverdetail.push(employeeItem);
          });
        }
        if (approvertype.displayvalue != 3) {
          data.approverdetail.push(approverTypeItem);
        }
      });
      // this.setState({showEmployeeList : false})
      const approvalworkflowInfo = this.props.approvalWorkflowReducer;
      if (approvalworkflowInfo.approvalworkflowdetail && !isskip) {
        const index = approvalworkflowInfo.approvalworkflowdetail.findIndex(
          (x) => x.workflowfortypeid == data.workflowfortypeid,
        );
        index > -1
          ? (approvalworkflowInfo.approvalworkflowdetail[index] = data)
          : approvalworkflowInfo.approvalworkflowdetail.push(data);
      } else if (approvalworkflowInfo.approvalworkflowdetail && isskip) {
        const index = approvalworkflowInfo.approvalworkflowdetail.findIndex(
          (x) => x.workflowfortypeid == data.workflowfortypeid,
        );
        index > -1
          ? approvalworkflowInfo.approvalworkflowdetail.splice(index, 1)
          : approvalworkflowInfo.approvalworkflowdetail.pop();
      } else {
        approvalworkflowInfo.approvalworkflowdetail = [];
        approvalworkflowInfo.approvalworkflowdetail.push(data);
      }
      this.props.ApprovalWorkflow({ ...approvalworkflowInfo });
      this.props.setTabValue(this.props.nextid);
    }
  }

  OnSave() {
    this.UpdateApprovalWorkFlowReducer();
  }

  Skipandnext() {
    this.setState({ isskippable: true });
    const approvalworkflowdetail = this.props.approvalWorkflowReducer;
    approvalworkflowdetail.approvalreviewworkflowisskip = true;
    this.props.ApprovalWorkflow({ ...approvalworkflowdetail });
    this.props.setTabValue(this.props.nextid);
  }

  render() {
    return (
      <div>
        <div className="width600">
          <div style={{ marginBottom: 16 }}>
            <p className="large-text-dark-secondary t-bold margin-bottom-16">
              360˚ review Workflow
            </p>
            {/* <p style={{ fontSize: 14, opacity: 0.7 }}>
						General workflow covers employee bank-detail changes and probation confirmations.
						</p> */}
          </div>
          <div>
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbTypeofWorkflow"
                defaultMessage="What type of workflow would you like"
              />
            </p>
            <div
              className="depedent-select-list "
              onClick={this.handleExpandClick02}
              aria-expanded={this.state.expanded02}
            >
              <span
                style={{
                  fontSize: 14,
                  opacity: 0.7,
                  width: "94%",
                  display: "inline-block",
                }}
              >
                <span style={{ display: "block", fontWeight: "bold" }}>
                  <FormattedMessage
                    id="LbFreeflowingWorkflow"
                    defaultMessage="Free flowing workflow"
                  />
                </span>
                <span style={{ fontSize: 14, opacity: 0.7 }}>
                  In this workflow, any 1 of the recipients can approve the
                  request, irrespective of the number of recipients involved.
                </span>
              </span>
              {this.state.expanded02 == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected"></span>
              )}
            </div>
            {this.state.expanded02 == true ? (
              <div className="bottom-border"></div>
            ) : (
              ""
            )}
            <div>
              <Collapse
                in={this.state.expanded02}
                timeout="auto"
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <div>
                  <p className="form-input-label">
                    <FormattedMessage
                      id="LbPositionHierarchy"
                      defaultMessage="Select employees based on their position in hierarchy"
                    />
                  </p>
                  <div className="width100">
                    <Select
                      className="selectsearch"
                      onChange={this.UpdateApprovertypeIds}
                      isMulti
                      options={this.state.approverTypes}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      value={this.state.selectedApproverTypeIds}
                      placeholder="Select Approver"
                    />
                    <div>
                      {this.state.ErApprovalType == true ? (
                        <span className="caption-error">
                          <FormattedMessage
                            id="ErApprovalType"
                            defaultMessage="Please select approver type"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {this.state.showEmployeeList ? (
                    <div className="margin-top-16">
                      <p className="add-label-active">
                        <FormattedMessage
                          id="LbSpecificEmployees"
                          defaultMessage="Select certain specific employee who will also receive the request for action"
                        />
                      </p>
                      <div className="width100">
                        <Select
                          className="selectsearch"
                          onChange={this.UpdateEmployeeIds}
                          isMulti
                          options={this.state.employeeList}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={this.state.selectedEmployeeIds}
                          placeholder="Select Employee"
                        />
                        <div>
                          {this.state.ErEmployees == true ? (
                            <span className="caption-error">
                              <FormattedMessage
                                id="ErEmployees"
                                defaultMessage="Please select employee"
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Collapse>
            </div>
            <div>
              {this.state.ErApprovalworkflowtype == true ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErApprovalworkflowtype"
                    defaultMessage="Please select approver workflow type"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <p className="depedent-select-list-head margin-bottom-16">
            If you'd like to give special permissions to the Approver, please
            select them below{" "}
          </p>
          <div>
            <DynamicForm
              fields={checkboxinputconverter({
                value:
                  this.state.approvalpermission &&
                  this.state.approvalpermission.isskipparticipant,
                placeholder: "",
                label:
                  "Approver can 'skip' specific people from a particular review",
              })}
              onChange={(value) => {
                this.handleChange(value, "isskipparticipant");
              }}
            />
          </div>
          <div>
            <DynamicForm
              fields={checkboxinputconverter({
                value:
                  this.state.approvalpermission &&
                  this.state.approvalpermission.isexcluderating,
                placeholder: "",
                label: "Exclude specific review ratings from final rating?",
              })}
              onChange={(value) => {
                this.handleChange(value, "isexcluderating");
              }}
            />
          </div>
          <div>
            <DynamicForm
              fields={checkboxinputconverter({
                value:
                  this.state.approvalpermission &&
                  this.state.approvalpermission.isadhoc,
                placeholder: "",
                label:
                  "Approver can add specific people to any particular on-going/upcoming review (ad-hoc)",
              })}
              onChange={(value) => {
                this.handleChange(value, "isadhoc");
              }}
            />
          </div>
          <div>
            <DynamicForm
              fields={checkboxinputconverter({
                value:
                  this.state.approvalpermission &&
                  this.state.approvalpermission.isreleased,
                placeholder: "",
                label:
                  "Hold, Cancel & release feedback, before designated end date of a review cycle ",
              })}
              onChange={(value) => {
                this.handleChange(value, "isreleased");
              }}
            />
          </div>
          <div>
            <DynamicForm
              fields={checkboxinputconverter({
                value:
                  this.state.approvalpermission &&
                  this.state.approvalpermission.ispreference,
                placeholder: "",
                label: "Approver can add preferences",
              })}
              onChange={(value) => {
                this.handleChange(value, "ispreference");
              }}
            />
          </div>
          <div className="padding-top-20">
            <Button
              className="btn btn-secondary-md-blue"
              variant="contained"
              color="primary"
              size="large"
              onClick={this.Skipandnext.bind(this)}
            >
              Skip
            </Button>
            <Button
              variant="contained"
              className="btn btn-primary-md-blue margin-left-20"
              color="primary"
              size="large"
              onClick={this.OnSave.bind(this)}
            >
              Save & next
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

ReviewWorkflow.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  approvalWorkflowReducer: state.approvalWorkflowReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ApprovalWorkflow: (data) => ApprovalWorkflow(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(ReviewWorkflow)));
